import React from "react";
import { array, string } from "prop-types";
import CardImageType1 from "../../molecules/card-image-type-1";
import CarouselSlider from "../../molecules/carousel-slider";
import Headline from "../../atoms/headline";

import "./related-stories.m.css";

const RelatedStories = ({ relatedStories = [], collectionName }) => {
  const filteredCollectionData = relatedStories
    .filter(item => item.type === "story")
    .sort((a, b) => b.story["published-at"] - a.story["published-at"])
    .slice(0, 4);

  const collectionData = {
    items: filteredCollectionData.map(item => {
      item.type = "story";
      return item;
    })
  };

  return relatedStories && relatedStories.length > 0 ? (
    <div styleName="wrapper">
      {collectionName && (
        <div styleName="collection-name">
          <Headline text={collectionName} headerType={13} headerLevel={3} />
        </div>
      )}
      <div styleName="content">
        {global.width < 768 && <CarouselSlider collection={collectionData} />}
        {global.width > 768 &&
          filteredCollectionData.map((item, index) => (
            <CardImageType1 story={item.story ? item.story : item} key={index} widths={[250, 520]} />
          ))}
      </div>
    </div>
  ) : null;
};

RelatedStories.propTypes = {
  relatedStories: array,
  collectionName: string
};

export default RelatedStories;
